import { APIService } from "../../apiService";
import { AuthenticationService } from "../../authenticationService";
import { S3SignedUrl } from "src/types";
import { PostPurchaseOrdersInvoiceExportsRequestBody } from "src/types/api";

export type InvoiceExportDetail = {
  id: string;
  vendorName?: string;
  invoiceName?: string;
  lastModified: string;
  signedUrl: S3SignedUrl;
  invoiceDueDate?: string;
  invoiceNote?: { body: string; date: string; tag: string };
  invoiceReferenceNumber?: string;
  totalInvoices: number;
};

class InvoiceExportAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/finance");
  }

  async postInvoiceExports(requestBody: PostPurchaseOrdersInvoiceExportsRequestBody): Promise<InvoiceExportDetail[]> {
    return await this.jwtRequest("POST", "/invoice-exports", requestBody);
  }

  async postLegacyInvoiceExports(
    requestBody: PostPurchaseOrdersInvoiceExportsRequestBody
  ): Promise<InvoiceExportDetail[]> {
    return await this.jwtRequest("POST", "/legacy-invoice-exports", requestBody);
  }
}

export { InvoiceExportAPIService };
